import { render, staticRenderFns } from "./FinalizedProduct.vue?vue&type=template&id=5b9222d2&"
import script from "./FinalizedProduct.vue?vue&type=script&lang=ts&"
export * from "./FinalizedProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports